import { DEFAULT_LOCALE, EMPTY_ARR, EMPTY_OBJ } from '@constants';

import useResourceList from './useResourceList';
import mutationFactory from './mutationFactory';
import useQuery from './useQuery';

import api from '..';

export const useRulesList = (queryVariables = {}, queryConfig = {}) => {
  const queryResult = useResourceList({ name: 'rules', api: api.rules }, queryVariables, queryConfig);

  return {
    rules: queryResult.resolvedData,
    latestRules: queryResult.latestData,
    ...queryResult,
  };
};

export const useRulesByIds = ({ ids, locale = DEFAULT_LOCALE, withFallback }, queryConfig = {}) => {
  const queryResult = useQuery(['rulesByIds', { ids, locale, withFallback }], api.rules.getByIds, {
    ...queryConfig,
    enabled: ids?.length > 0,
  });

  return {
    rules: queryResult.data || EMPTY_ARR,
    ...queryResult,
  };
};

export const useRule = ({ id, locale = DEFAULT_LOCALE }, queryConfig = {}) => {
  const queryResult = useQuery(['rule', { id, locale }], api.rules.getById, {
    ...queryConfig,
    enabled: id,
  });

  return {
    rule: queryResult.data || EMPTY_OBJ,
    ...queryResult,
  };
};

const createMutation = mutationFactory({ invalidate: 'rulesByIds' });

export const useDeleteRule = createMutation(api.rules.remove);

export const useCreateRule = createMutation(api.rules.create);

export const useUpdateRule = createMutation(api.rules.update);

export const useUpsertRule = createMutation(api.rules.upsert);

export const usePublishRule = createMutation(api.rules.publish);

export const useUnpublishRule = createMutation(api.rules.unpublish);

export const useDuplicateRule = createMutation(api.rules.duplicate);
